// Gsap
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initPresentationInteractive() {
    const activateClick = false;
    const presentationInteractive = document.querySelectorAll(
        '.presentation-interactive .inner-wrapper'
    );

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (presentationInteractive.length) {
        presentationInteractive.forEach((block) => {
            const visual = block.querySelector('.visuals-list');

            const allVisuals = visual.querySelectorAll('.visual-item');
            const allTitles = block.querySelectorAll('.title-item');

            ScrollTrigger.create({
                trigger: visual,
                start: () => (isMobile ? 'bottom 95%' : '50% 50%'),
                end: () =>
                    '+=' +
                    (isMobile
                        ? block.offsetHeight - window.innerHeight / 2 + 'px'
                        : block.offsetHeight - window.innerHeight / 2 + 'px'),
                scrub: false,
                pin: visual,
                pinSpacing: true,
                markers: false,
                anticipatePin: 1,
                onUpdate: (self) => {
                    const percent = self.progress * 100;
                    const totalItems = allVisuals.length;

                    let index = Math.round((totalItems / 100) * percent);

                    allVisuals.forEach((visualItem) => {
                        visualItem.classList.remove('is-active');
                    });
                    allTitles.forEach((titleItem) => {
                        titleItem.classList.remove('is-active');
                    });

                    if (!allVisuals[index]) {
                        index = allVisuals.length - 1;
                    }

                    allVisuals[index].classList.add('is-active');
                    allTitles[index].classList.add('is-active');
                },
                onLeave: () => {
                    allVisuals.forEach((visualItem) => {
                        visualItem.classList.remove('is-active');
                    });
                    allTitles.forEach((titleItem) => {
                        titleItem.classList.remove('is-active');
                    });

                    allVisuals[allVisuals.length - 1].classList.add('is-active');
                    allTitles[allVisuals.length - 1].classList.add('is-active');
                },
                onLeaveBack: () => {
                    allVisuals.forEach((visualItem) => {
                        visualItem.classList.remove('is-active');
                    });
                    allTitles.forEach((titleItem) => {
                        titleItem.classList.remove('is-active');
                    });

                    allVisuals[0].classList.add('is-active');
                    allTitles[0].classList.add('is-active');
                },
            });

            setTimeout(() => {
                ScrollTrigger.refresh();

                setTimeout(() => {
                    ScrollTrigger.refresh();

                    if (!activateClick) {
                        return;
                    }

                    const blockTopPositionRelativeToBody = document.querySelector(
                        '.presentation-interactive'
                    ).offsetTop;
                    const titleItemHeight = allTitles[0].offsetHeight - 20;

                    // console.log(blockTopPositionRelativeToBody);
                    allTitles.forEach((titleItem) => {
                        titleItem.addEventListener('click', () => {
                            const index = [...allTitles].indexOf(titleItem);

                            window.scrollTo({
                                top: blockTopPositionRelativeToBody + titleItemHeight * index,
                                behavior: 'smooth',
                            });
                        });
                    });
                }, 2500);
            }, 1000);
        });
    }
}
